import React, { useContext } from 'react';
import { mergeStyles, Text } from '@fluentui/react';
import { getThemeFromString } from '../../../../../Common/util/localStorageUtils';
import { ThemeContext } from '../../../../../HubLayout/models/ThemeContext';
import { CopyButton } from './CopyButton';

export const SreFact: React.FC<{
    label: string;
    value?: string | number | null;
    copyable?: boolean;
    copyAs?: string;
}> = ({ label, value, copyable = false, copyAs }) => {
    const { themeName } = useContext(ThemeContext);
    const theme = getThemeFromString(themeName);
    const hasValue = value !== undefined && value !== null && value !== '';
    const canCopy = copyable && hasValue;

    return (
        <div
            className={mergeStyles({
                display: 'grid',
                gridTemplateColumns: 'minmax(90px, 130px) minmax(0, 1fr)',
                columnGap: '12px',
                rowGap: '4px',
                alignItems: 'start',
                minWidth: 0,
                selectors: {
                    '@media (max-width: 600px)': {
                        gridTemplateColumns: 'minmax(0, 1fr)',
                    },
                },
            })}
        >
            <Text
                variant="small"
                styles={{
                    root: {
                        fontWeight: 600,
                        color: theme.palette.neutralSecondary,
                        paddingTop: canCopy ? 7 : 0,
                    },
                }}
            >
                {label}
            </Text>
            <div
                role={canCopy ? 'group' : undefined}
                aria-label={canCopy ? label : undefined}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    minWidth: 0,
                    border: canCopy
                        ? `1px solid ${theme.palette.neutralTertiaryAlt}`
                        : undefined,
                    borderRadius: 4,
                    background: canCopy
                        ? theme.palette.neutralLighterAlt
                        : undefined,
                    padding: canCopy ? '4px 6px 4px 10px' : 0,
                }}
            >
                <Text
                    variant="small"
                    styles={{
                        root: {
                            overflowWrap: 'anywhere',
                            whiteSpace: 'pre-wrap',
                            minWidth: 0,
                            flex: 1,
                            userSelect: 'text',
                            fontFamily: canCopy ? 'monospace' : undefined,
                        },
                    }}
                >
                    {hasValue ? value : 'Not recorded'}
                </Text>
                {canCopy && (
                    <CopyButton
                        label={label}
                        value={copyAs ?? String(value)}
                        size="medium"
                    />
                )}
            </div>
        </div>
    );
};
